import { render, staticRenderFns } from "./NewsMonthFilter.vue?vue&type=template&id=525592a6"
import script from "./NewsMonthFilter.vue?vue&type=script&lang=js"
export * from "./NewsMonthFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports